import APIContext from 'contexts/base/APIContext'

export default class LogReferencesContext extends APIContext{
  static contextName = 'logReferences'
}
